(() => {
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const toast=(msg)=>{const el=q('[data-toast]'); if(!el)return; el.textContent=msg; el.classList.add('is-visible'); setTimeout(()=>el.classList.remove('is-visible'),2200)};
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-search-open]'); if(open){q('[data-search-drawer]')?.classList.add('is-open'); q('[data-search-drawer] input')?.focus()}
    const close=e.target.closest('[data-search-close]'); if(close){q('[data-search-drawer]')?.classList.remove('is-open')}
  });
  qa('[data-product-form]').forEach(form=>{
    const variantData=JSON.parse(form.querySelector('[data-variants-json]')?.textContent||'[]');
    const idInput=form.querySelector('[name="id"]');
    const add=form.querySelector('[data-add-to-bag]');
    const checkout=form.querySelector('[data-product-checkout]');
    const error=form.querySelector('[data-product-error]');
    let busy=false;
    let selectedAvailable=false;
    const price=q('[data-product-price]');
    const update=()=>{
      const selections={}; qa('[data-option-index]',form).forEach(group=>{const checked=q('input:checked',group); if(checked) selections[group.dataset.optionIndex]=checked.value});
      const variant=variantData.find(v=>v.options.every((opt,i)=>selections[i]===opt));
      selectedAvailable=!!variant?.available;
      if(checkout)checkout.disabled=busy||!selectedAvailable;
      if(!variant){if(add){add.disabled=true;add.textContent='Unavailable'}; return}
      idInput.value=variant.id; if(price)price.textContent=window.Shopify?.formatMoney?Shopify.formatMoney(variant.price):variant.priceFormatted;
      if(add){add.disabled=busy||!variant.available;add.textContent=variant.available?'Add to bag':'Sold out'};
      const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({},'',u);
    };
    form.addEventListener('change',update); update();
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(busy||!selectedAvailable)return;
      const direct=e.submitter===checkout;
      const active=direct?checkout:add;
      const old=active.textContent;
      const data=new FormData(form);
      busy=true;
      add.disabled=true;
      if(checkout)checkout.disabled=true;
      if(error)error.hidden=true;
      active.textContent=direct?checkout.dataset.loadingLabel:'Adding…';
      const root=window.Shopify?.routes?.root||'/';
      try{
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
        if(!res.ok)throw new Error();
        await res.json();
        if(direct){window.location.assign(root+'checkout');return}
        const cart=await fetch(root+'cart.js').then(r=>r.json());
        qa('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
        toast('Added to bag');
      }catch(err){if(error){error.textContent=error.dataset.message;error.hidden=false}else{toast('Could not add this item. Please try again.')}}
      busy=false;
      active.textContent=old;
      update();
    });
  });
  qa('[data-quick-add]').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const btn=q('button',form),old=btn.textContent;btn.textContent='Adding…';btn.disabled=true;try{const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});if(!res.ok)throw new Error();const cart=await fetch('/cart.js').then(r=>r.json());qa('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);toast('Added to bag');btn.textContent='Added'}catch(_){toast('Could not add this item');btn.textContent=old}setTimeout(()=>{btn.textContent=old;btn.disabled=false},900)}));
  const ship=q('[data-shipping-form]');
  if(ship){
    const out=q('[data-shipping-results]');
    const submit=q('[data-shipping-submit]',ship);
    const countrySelect=q('[name="country"]',ship);
    if([...countrySelect.options].some(option=>option.value==='Australia')) countrySelect.value='Australia';
    let autoTimer;
    let requestVersion=0;
    ship.addEventListener('change',()=>{clearTimeout(autoTimer);requestVersion++;out.textContent='';if(submit){submit.disabled=false;submit.textContent='Check live rates'}});
    const wait=(ms)=>new Promise(r=>setTimeout(r,ms));
    const paramsFromForm=()=>{const fd=new FormData(ship),params=new URLSearchParams();for(const [k,v] of fd)params.set(`shipping_address[${k}]`,String(v).trim());return params};
    const loadRates=async()=>{
      const zip=q('[name="zip"]',ship)?.value.trim();
      const country=q('[name="country"]',ship)?.value;
      if(!zip){out.innerHTML='<div class="shipping-error">Enter a postcode or ZIP to see live rates.</div>';return}
      if(country==='Australia'&&!/^\d{4}$/.test(zip)){out.innerHTML='<div class="shipping-error">Australian postcodes need 4 digits.</div>';return}
      const version=++requestVersion;
      const params=paramsFromForm();
      const old=submit?.textContent||'Check live rates';
      if(submit){submit.disabled=true;submit.textContent='Checking…'}
      out.innerHTML='<div class="shipping-status">Checking live Shopify rates…</div>';
      try{
        const prep=await fetch('/cart/prepare_shipping_rates.json',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},body:params.toString()});
        if(!prep.ok){let d={};try{d=await prep.json()}catch(_){ }throw new Error(d?.message||d?.error||'Address could not be rated')}
        let rates=null;
        for(let i=0;i<7;i++){
          await wait(i===0?250:500);
          const poll=await fetch('/cart/async_shipping_rates.json?'+params.toString(),{headers:{'Accept':'application/json'}});
          if(poll.status===202) continue;
          if(!poll.ok){let d={};try{d=await poll.json()}catch(_){ }throw new Error(d?.message||d?.error||'Unable to calculate shipping')}
          const data=await poll.json();
          if(data&&Array.isArray(data.shipping_rates)){rates=data.shipping_rates;break}
        }
        if(version!==requestVersion)return;
        if(!rates) throw new Error('Rates are taking longer than expected. Please try once more.');
        if(!rates.length){out.innerHTML='<div class="shipping-error">No shipping service was returned for that destination. Check the postcode and try again.</div>';return}
        out.innerHTML='<div class="shipping-success">Live rates found</div>'+rates.map(x=>`<div class="shipping-rate"><strong>${x.name}</strong><span>${x.price} ${x.currency||''}</span></div>`).join('');
      }catch(err){if(version!==requestVersion)return;out.innerHTML=`<div class="shipping-error">${err.message||'Could not load shipping rates. Check the address and try again.'}</div>`}
      finally{if(submit&&version===requestVersion){submit.disabled=false;submit.textContent=old}}
    };
    ship.addEventListener('submit',e=>{e.preventDefault();loadRates()});
    q('[name="zip"]',ship)?.addEventListener('input',()=>{clearTimeout(autoTimer);const country=q('[name="country"]',ship)?.value;const zip=q('[name="zip"]',ship)?.value.trim();if(country==='Australia'&&/^\d{4}$/.test(zip))autoTimer=setTimeout(loadRates,450)});
  }
})();

/* FSC v1.1 product carousel */
document.querySelectorAll('[data-product-carousel]').forEach((carousel)=>{
  const slides=[...carousel.querySelectorAll('[data-carousel-slide]')];
  const thumbs=[...carousel.querySelectorAll('[data-carousel-thumb]')];
  if(!slides.length) return;
  let index=0;
  const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((s,i)=>s.classList.toggle('is-active',i===index));thumbs.forEach((t,i)=>t.classList.toggle('is-active',i===index));const active=thumbs[index];if(active)active.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});};
  carousel.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>show(index-1));
  carousel.querySelector('[data-carousel-next]')?.addEventListener('click',()=>show(index+1));
  thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
  let startX=null;const viewport=carousel.querySelector('[data-carousel-viewport]');
  viewport?.addEventListener('touchstart',(e)=>{startX=e.changedTouches[0].clientX},{passive:true});
  viewport?.addEventListener('touchend',(e)=>{if(startX===null)return;const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1));startX=null},{passive:true});
});


/* FSC v1.6 conversion confidence helpers */
document.querySelectorAll('[data-size-guide-jump]').forEach((link)=>{link.addEventListener('click',()=>{const details=document.getElementById('product-size-guide');if(details)details.open=true;setTimeout(()=>{const table=details?.querySelector('#size-guide');(table||details)?.scrollIntoView({behavior:'smooth',block:'start'})},50)})});
document.querySelectorAll('[data-size-guide-card]').forEach((card)=>{const source=card.querySelector('.size-guide-source');const target=card.querySelector('[data-size-guide-target]');const table=source?.querySelector('table#size-guide');if(table&&target)target.appendChild(table.cloneNode(true));else if(target)target.innerHTML='<p class="muted">This silhouette does not currently expose a separate measurement table. Use the exact product page fit notes before ordering.</p>'});
const judgeRoot=document.querySelector('[data-judgeme-product-reviews]');if(judgeRoot){const fallback=judgeRoot.querySelector('[data-judgeme-fallback]');const widget=judgeRoot.querySelector('#judgeme_product_reviews');const judgeHasReviews=()=>!!widget&&(widget.querySelector('.jdgm-rev,.jdgm-rev-widg')||/Based on\s+\d+\s+review/i.test(widget.textContent||''));if(judgeHasReviews()&&fallback)fallback.hidden=true;else{const obs=new MutationObserver(()=>{if(judgeHasReviews()&&fallback){fallback.hidden=true;obs.disconnect()}});if(widget)obs.observe(widget,{childList:true,subtree:true,characterData:true});setTimeout(()=>obs.disconnect(),7000)}}

(() => {
  const init = (root) => {
    root.querySelectorAll('[data-card-carousel]').forEach(card => {
      if (card.dataset.cardReady) return;
      const data = card.querySelector('[data-card-images]');
      const img = card.querySelector('[data-card-link] img');
      if (!data || !img) return;
      let images;
      try { images = JSON.parse(data.textContent); } catch { return; }
      if (images.length < 2) return;
      card.dataset.cardReady = 'true';
      const prev = card.querySelector('[data-card-prev]');
      const next = card.querySelector('[data-card-next]');
      const count = card.querySelector('[data-card-count]');
      const link = card.querySelector('[data-card-link]');
      let index = 0;
      let sequence = 0;
      let start = null;
      let suppressClick = false;
      const show = (step) => {
        index = (index + step + images.length) % images.length;
        const target = images[index];
        const request = ++sequence;
        const incoming = new Image();
        incoming.onload = () => {
          if (request !== sequence) return;
          img.removeAttribute('srcset');
          img.src = target.src;
          img.alt = target.alt;
          count.textContent = `${index + 1} / ${images.length}`;
        };
        incoming.onerror = () => { if (request === sequence) index = Number(count.textContent.split('/')[0]) - 1; };
        incoming.src = target.src;
      };
      prev.hidden = next.hidden = count.hidden = false;
      count.textContent = `1 / ${images.length}`;
      prev.addEventListener('click', () => show(-1));
      next.addEventListener('click', () => show(1));
      card.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        show(e.key === 'ArrowLeft' ? -1 : 1);
      });
      link.addEventListener('touchstart', e => { suppressClick = false; start = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null; }, {passive:true});
      link.addEventListener('touchend', e => {
        if (!start) return;
        const dx = e.changedTouches[0].clientX - start.x;
        const dy = e.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          suppressClick = true;
          show(dx < 0 ? 1 : -1);
        }
      }, {passive:true});
      link.addEventListener('touchcancel', () => { start = null; }, {passive:true});
      link.addEventListener('click', e => { if (suppressClick) { e.preventDefault(); suppressClick = false; } });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
